const sounds = {
  playCard: '/assets/sounds/playCard.mp3',
  drawCard: '/assets/sounds/drawCard.mp3',
  specialCard: '/assets/sounds/specialCard.mp3',
  playerJoin: '/assets/sounds/playerJoin.mp3',
  yourTurn: '/assets/sounds/yourTurn.mp3',
  gameWin: '/assets/sounds/gameWin.mp3',
  backgroundMusic: '/assets/sounds/backgroundMusic.mp3',
  // Add more sounds as needed
};

let isMuted = false;
const audioCache = {}; // To cache Audio objects

const SoundService = {
  loadSounds: () => {
    for (const key in sounds) {
      if (sounds.hasOwnProperty(key)) {
        const audio = new Audio(sounds[key]);
        audio.load(); // Preload the sound
        audioCache[key] = audio;
      }
    }
    console.log('Sounds preloaded (or at least initiated loading)');
  },

  playSound: (soundKey) => {
    if (isMuted && soundKey !== 'backgroundMusic') return;

    const audio = audioCache[soundKey];
    if (audio) {
      if (soundKey !== 'backgroundMusic') {
        audio.currentTime = 0;
      }
      audio.play().catch(error => {
        // Autoplay was prevented or another error occurred
        console.warn(`SoundService: Could not play sound - ${soundKey}:`, error);
        // This often happens if the user hasn't interacted with the page yet.
        // Or if the sound file path is incorrect / file is missing.
      });
    } else {
      console.warn(`SoundService: Sound key "${soundKey}" not found or not loaded.`);
    }
  },

  playBackgroundMusic: () => {
    const bgMusic = audioCache['backgroundMusic'];
    if (bgMusic) {
      bgMusic.loop = true;
      bgMusic.muted = isMuted;
      if (!bgMusic.paused) return;
      bgMusic.play().catch(error => {
        console.warn('SoundService: Could not play background music:', error);
      });
    } else {
      console.warn('SoundService: Background music not loaded.');
    }
  },

  stopBackgroundMusic: () => {
    const bgMusic = audioCache['backgroundMusic'];
    if (bgMusic) {
      bgMusic.pause();
      bgMusic.currentTime = 0;
    }
  },

  toggleMute: () => {
    isMuted = !isMuted;
    console.log(`SoundService: Mute is now ${isMuted ? 'ON' : 'OFF'}`);
    
    for (const key in audioCache) {
      if (audioCache.hasOwnProperty(key) && audioCache[key]) {
        if (key === 'backgroundMusic') {
          audioCache[key].muted = isMuted;
        } else if (isMuted && !audioCache[key].paused) {
          audioCache[key].pause();
          audioCache[key].currentTime = 0;
        }
      }
    }
    return isMuted;
  },

  getMuteState: () => {
    return isMuted;
  },
};

// Optional: Preload sounds when the service is imported/initialized
// However, it's often better to call loadSounds() after user interaction or once the app is ready.
// SoundService.loadSounds(); 

export default SoundService; 